import { useEffect, useState, useContext } from "react"
import { useNavigate, useLocation } from "react-router-dom";
import { SettingsContext } from "../../providers/settings";
import HomePageLayout from "../../layouts/HomePage/HomePageLayout";
import { 
    Stack, Grid, 
    GTIWebDataGrid, GTIWebButton
} from "@gti-controls-v2/web-core";
import { titleIcons } from "../../common/constants/TitleIcons";
import Title from "../../components/title";
import { GTIWebModal } from "../../components/modal";
import SecondaryTitle from "../../components/title/secondary-title";
import homePageStyles from "../../common/styles/HomePage";
import useUnificar from "../../hooks/useUnificar";
import { paths } from "../../common/constants/Rutas";


const UnificarCURP = () => {
    const styles = homePageStyles;

    const navigate = useNavigate();
    const location = useLocation();
    const { handleLoading } = useContext(SettingsContext);
    const { putCURPUnificar } = useUnificar();
    const [dataHeader, setDataHeader] = useState(null);
    const [dataSet, setDataSet] = useState([]);
    const [userInfo, setUserInfo] = useState(null);
    const [open, setOpen] = useState(false);
    const [modalConfig, setModalConfig] = useState({
        title: "No pudimos completar la unificación",
        description: "",
        icon: titleIcons.error
    });

    const columns =[
		{ field: 'NominaNumero', headerName: '#', width: 150, type: 'number' },
		{ field: 'AnteriorCURP', headerName: 'CURP', width: 300 },
		{ field: 'NominaNombre', headerName: 'Nombre', width: 300 },
		{ field: 'AutoUserRegistrado', headerName: 'Registrado', width: 150 },
	];

    useEffect(() => {
        const state = location.state || {};

        handleLoading(true);

        if (location?.state?.header) {
            setDataHeader([
                { label: 'Número de empleado', value: state.header.NominaNumero },
                { label: 'Nombre', value: state.header.NominaNombre },
                { label: 'CURP más reciente', value: state.header.NominaCURP }
            ]);

            setDataSet(state.nominas);
            setUserInfo({ ...state.header, EmpresaID: state.EmpresaID });
        } else {
            navigate(paths.TicketPage);
        }
        

        handleLoading(false);
        // eslint-disable-next-line
    }, [location.state])

    const submit = async () => {
        handleLoading(true);
        let curps = dataSet.map(a => a.AnteriorCURP);

		let body = {
			"empresaId": userInfo.EmpresaID,
			"autoEmpNumero": userInfo.NominaNumero,
			"oldCURPs": curps,
			"newCURP": userInfo.NominaCURP
		};

        const result = await putCURPUnificar(body);

        if (result.exitoso) {
            setModalConfig({
                title: "Unificación realizada con éxito",
                description: "Todos los recibos de nómina del empleado ahora están ligados a una sola CURP.",
                icon: titleIcons.done
            });
            setOpen(true);
        } else {
            setModalConfig({
                ...modalConfig,
                description: result.data
            });
            setOpen(true);
        }

        handleLoading(false);
    };

    const handleBack = () => {
        navigate(paths.TicketPage, { state: { TicketID: location.state.TicketID } });
    };

    const onCloseModal = () => {
        navigate(paths.TicketPage, { state: { TicketID: location.state.TicketID } });
        setOpen(!open);
    };

    return (
        <HomePageLayout isForm>
            <Stack direction="column" spacing={2} align="left" paddingBottom={5}>
                <Stack direction="row" spacing={2} alignItems="center">
                    <Title>Unificar CURP</Title>
                </Stack>
            </Stack>

            { dataHeader && <SecondaryTitle data={dataHeader} /> }

            <Grid marginTop={4}>
                <Grid container direction="column">
                    <GTIWebDataGrid
                        rows={dataSet}
                        columns={columns}
                        getRowId={(r) => r.AnteriorCURP}
                        disableColumnMenu
                        disableColumnSelector
                        disableClearSelectionOnFilter
                    />
                </Grid>
            </Grid>

            <div style={styles.confirmUnify}>
                <span>¿Confirmas que deseas realizar el proceso de unificación utilizando la CURP más reciente?</span>
            </div>

            <Stack spacing={2} direction="row" pt={5}>
                <GTIWebButton text={"Aceptar"} onClick={submit} /> 
                <GTIWebButton text={"Cancelar"} variant="outlined" onClick={handleBack} />
            </Stack>

            <Grid>
                <GTIWebModal 
                    open={open}
                    title={modalConfig.title}
                    description={modalConfig.description}
                    hideCancelButton
                    onClose={onCloseModal}
                    icon={modalConfig.icon}
                />
            </Grid>
        </HomePageLayout>
    )
};

export default UnificarCURP;